module.exports = __webpack_public_path__ + "img/27.4c1a4aea.jpg";